import { CheckCircle2, Clock, DollarSign, Sparkles } from 'lucide-react';

export const mockFeatures = [
  {
    icon: <CheckCircle2 className="w-6 h-6 text-cyan-400" />,
    title: "Premium Quality",
    description: "High-resolution printing with vibrant colors and sharp details"
  },
  {
    icon: <Clock className="w-6 h-6 text-cyan-400" />,
    title: "Fast Turnaround",
    description: "Quick delivery without compromising on quality standards"
  },
  {
    icon: <DollarSign className="w-6 h-6 text-cyan-400" />,
    title: "Affordable Pricing",
    description: "Competitive rates with transparent pricing and no hidden costs"
  },
  {
    icon: <Sparkles className="w-6 h-6 text-cyan-400" />,
    title: "Custom Solutions",
    description: "Tailored printing services to match your unique requirements"
  }
];

export const mockServices = [
  {
    title: "Visiting Cards",
    description: "Professional business cards with premium finishes. Multiple paper options and custom designs available.",
    image: "https://customer-assets.emergentagent.com/job_print-solutions-86/artifacts/jf1i50fd_Insurance%20Business%20Card%20Design%20Inspiration.jpg",
    specifications: [
      { label: "Size", value: "3.5\" x 2\" (Standard) / Custom sizes available" },
      { label: "Material", value: "Premium cardstock, Matte/Glossy finish" },
      { label: "Thickness", value: "300-400 GSM" },
      { label: "Printing", value: "Single/Double sided, Full color" },
      { label: "Quantity", value: "Minimum 100 cards" },
      { label: "Turnaround", value: "2-3 business days" }
    ]
  },
  {
    title: "Brochures & Catalogues",
    description: "Eye-catching brochures and detailed catalogues to showcase your products and services effectively.",
    image: "https://customer-assets.emergentagent.com/job_print-solutions-86/artifacts/4gqrbhif_download%20%281%29.jpg",
    specifications: [
      { label: "Sizes", value: "A4, A5, DL or custom" },
      { label: "Folding", value: "Bi-fold, Tri-fold, Z-fold" },
      { label: "Paper", value: "130-300 GSM Art/Matt paper" },
      { label: "Pages", value: "4 to 100+ pages" },
      { label: "Binding", value: "Saddle stitch, Perfect binding" },
      { label: "Turnaround", value: "3-5 business days" }
    ]
  },
  {
    title: "Banners & Flex",
    description: "Large format printing for banners, flex boards, and outdoor advertising with weather-resistant materials.",
    image: "https://customer-assets.emergentagent.com/job_print-solutions-86/artifacts/u4wafv83_Engaging%20Real%20Estate%20Roll%20Up%20Banner%20Design%20Inspiration.jpg",
    specifications: [
      { label: "Material", value: "Flex, Vinyl, Canvas" },
      { label: "Size", value: "Any custom size available" },
      { label: "Printing", value: "High-resolution digital printing" },
      { label: "Durability", value: "Weather-resistant, UV protected" },
      { label: "Finishing", value: "Hemming, Eyelets, Stand options" },
      { label: "Turnaround", value: "2-4 business days" }
    ]
  },
  {
    title: "Custom Shape Stickers",
    description: "High-quality custom shape stickers in any design, perfect for branding, labels, and promotional materials.",
    image: "https://customer-assets.emergentagent.com/job_print-solutions-86/artifacts/94v2xe7e_Stiker%20Adhesivo%20y%20Rotulado.jpg",
    specifications: [
      { label: "Shape", value: "Round, Square, Custom die-cut" },
      { label: "Material", value: "Vinyl, Paper, Transparent" },
      { label: "Finish", value: "Matte, Glossy, Laminated" },
      { label: "Adhesive", value: "Permanent or removable" },
      { label: "Sizes", value: "Any custom size" },
      { label: "Turnaround", value: "2-3 business days" }
    ]
  },
  {
    title: "Custom Carry Bags",
    description: "Premium custom printed carry bags for retail, events, and promotional purposes with strong handles.",
    image: "https://customer-assets.emergentagent.com/job_print-solutions-86/artifacts/m8ga2xc2_download.jpg",
    specifications: [
      { label: "Material", value: "Paper, Non-woven, Jute" },
      { label: "Sizes", value: "Small, Medium, Large, Custom" },
      { label: "Handle", value: "Rope, Ribbon, Die-cut" },
      { label: "Printing", value: "1-4 color printing" },
      { label: "Capacity", value: "2-10 kg load capacity" },
      { label: "Turnaround", value: "5-7 business days" }
    ]
  },
  {
    title: "Letterhead",
    description: "Professional letterhead printing with elegant designs to elevate your business correspondence.",
    image: "https://customer-assets.emergentagent.com/job_print-solutions-86/artifacts/4agpgddn_This%20item%20is%20unavailable%20-%20Etsy.jpg",
    specifications: [
      { label: "Size", value: "A4 (8.27\" x 11.69\")" },
      { label: "Paper", value: "100-120 GSM bond paper" },
      { label: "Printing", value: "Single side, Full color" },
      { label: "Finish", value: "Premium quality finish" },
      { label: "Quantity", value: "Minimum 100 sheets" },
      { label: "Turnaround", value: "2-3 business days" }
    ]
  },
  {
    title: "Custom Desktop Calendar",
    description: "Personalized desktop calendars with custom designs, perfect for corporate gifts and promotional items.",
    image: "https://customer-assets.emergentagent.com/job_print-solutions-86/artifacts/5vnp2pbj_Desktop%20Calender.jpg",
    specifications: [
      { label: "Type", value: "Desktop, Wall, Table" },
      { label: "Pages", value: "12 months + cover" },
      { label: "Paper", value: "250-300 GSM art card" },
      { label: "Binding", value: "Spiral, Wire-O" },
      { label: "Customization", value: "Logo, Images, Dates" },
      { label: "Turnaround", value: "5-7 business days" }
    ]
  },
  {
    title: "Custom Envelopes",
    description: "Custom printed envelopes in various sizes with your logo and branding for professional mailings.",
    image: "https://customer-assets.emergentagent.com/job_print-solutions-86/artifacts/uqkzy8gd_Custom%20Envelops.jpg",
    specifications: [
      { label: "Sizes", value: "DL, C5, C4, or custom" },
      { label: "Paper", value: "80-120 GSM" },
      { label: "Window", value: "With or without window" },
      { label: "Printing", value: "Front/Back, Full color" },
      { label: "Quantity", value: "Minimum 500 pieces" },
      { label: "Turnaround", value: "3-4 business days" }
    ]
  },
  {
    title: "Stamps",
    description: "Custom rubber stamps for office use, signatures, logos, and business documentation needs.",
    image: "https://customer-assets.emergentagent.com/job_print-solutions-86/artifacts/18jiqg1r_Stamps.jpg",
    specifications: [
      { label: "Type", value: "Self-inking, Traditional rubber" },
      { label: "Size", value: "Various sizes available" },
      { label: "Ink Color", value: "Black, Blue, Red, Green" },
      { label: "Impressions", value: "10,000+ impressions" },
      { label: "Custom", value: "Logo, Text, Date stamps" },
      { label: "Turnaround", value: "1-2 business days" }
    ]
  },
  {
    title: "Flyers",
    description: "High-impact promotional flyers and pamphlets to effectively market your business and events.",
    image: "https://customer-assets.emergentagent.com/job_print-solutions-86/artifacts/ypgdcjf2_Flyers.jpg",
    specifications: [
      { label: "Sizes", value: "A4, A5, A6, DL" },
      { label: "Paper", value: "130-170 GSM glossy/matte" },
      { label: "Printing", value: "Single/Double sided" },
      { label: "Finish", value: "Glossy or Matte lamination" },
      { label: "Quantity", value: "Starting from 100" },
      { label: "Turnaround", value: "2-3 business days" }
    ]
  },
  {
    title: "Certificates",
    description: "Professional certificate printing with premium paper quality for awards, diplomas, and achievements.",
    image: "https://customer-assets.emergentagent.com/job_print-solutions-86/artifacts/qtxxe7k1_Certificates.jpg",
    specifications: [
      { label: "Size", value: "A4 or custom sizes" },
      { label: "Paper", value: "200-300 GSM premium paper" },
      { label: "Printing", value: "Full color, Gold foiling option" },
      { label: "Finish", value: "Glossy, Matte, Embossed" },
      { label: "Quantity", value: "Minimum 50 certificates" },
      { label: "Turnaround", value: "3-4 business days" }
    ]
  },
  {
    title: "Booklets",
    description: "Multi-page booklet printing with binding options for manuals, catalogs, and informational materials.",
    image: "https://customer-assets.emergentagent.com/job_print-solutions-86/artifacts/sim7434r_Booklets.jpg",
    specifications: [
      { label: "Pages", value: "8 to 200+ pages" },
      { label: "Size", value: "A4, A5, or custom" },
      { label: "Paper", value: "100-150 GSM for inner pages" },
      { label: "Cover", value: "250-300 GSM art card" },
      { label: "Binding", value: "Saddle, Perfect, Spiral" },
      { label: "Turnaround", value: "4-6 business days" }
    ]
  },
  {
    title: "ID Cards",
    description: "Durable PVC ID cards with high-quality printing for employee badges, membership cards, and access cards.",
    image: "https://customer-assets.emergentagent.com/job_print-solutions-86/artifacts/emj4khas_ID%20Cards.jpg",
    specifications: [
      { label: "Material", value: "PVC, Plastic, Smart cards" },
      { label: "Size", value: "CR80 (3.375\" x 2.125\")" },
      { label: "Thickness", value: "0.76mm (30 mil)" },
      { label: "Printing", value: "Single/Double sided" },
      { label: "Features", value: "Barcode, QR code, Photo" },
      { label: "Turnaround", value: "3-5 business days" }
    ]
  },
  {
    title: "Canvas Prints",
    description: "Premium canvas printing for artwork, photos, and decorative wall art with gallery-quality finish.",
    image: "https://customer-assets.emergentagent.com/job_print-solutions-86/artifacts/96cddcxf_Canvas.jpg",
    specifications: [
      { label: "Material", value: "Premium cotton canvas" },
      { label: "Sizes", value: "8x10\" to 48x72\" or custom" },
      { label: "Frame", value: "Gallery wrap, Framed options" },
      { label: "Finish", value: "Matte or Glossy" },
      { label: "Resolution", value: "High-resolution printing" },
      { label: "Turnaround", value: "5-7 business days" }
    ]
  },
  {
    title: "LED Boards",
    description: "Eye-catching illuminated LED boards for signage and advertising with vibrant display quality.",
    image: "https://customer-assets.emergentagent.com/job_print-solutions-86/artifacts/528zl3oc_LED%20Board.JPEG",
    specifications: [
      { label: "Type", value: "3D LED letters, Backlit boards" },
      { label: "Material", value: "Acrylic, Metal, Aluminum" },
      { label: "LED Type", value: "RGB, Single color LEDs" },
      { label: "Power", value: "Low voltage, Energy efficient" },
      { label: "Customization", value: "Size, Shape, Color" },
      { label: "Turnaround", value: "7-10 business days" }
    ]
  },
  {
    title: "Table Tent Card",
    description: "Folded table tent cards perfect for restaurants, cafes, and events to showcase offers and menus.",
    image: "https://customer-assets.emergentagent.com/job_print-solutions-86/artifacts/63e6yzp0_Tent%20CARD.jpg",
    specifications: [
      { label: "Size", value: "4x6\", 5x7\" or custom" },
      { label: "Material", value: "250-350 GSM cardstock" },
      { label: "Fold", value: "A-frame, Pyramid style" },
      { label: "Printing", value: "Full color, Double sided" },
      { label: "Finish", value: "Glossy or Matte lamination" },
      { label: "Turnaround", value: "2-3 business days" }
    ]
  },
  {
    title: "Photos Printing",
    description: "High-resolution photo printing on premium paper for personal memories, portfolios, and exhibitions.",
    image: "https://customer-assets.emergentagent.com/job_print-solutions-86/artifacts/9mcs264y_Photo%20Strip%20Prints.jpg",
    specifications: [
      { label: "Sizes", value: "4x6\", 5x7\", 8x10\", custom" },
      { label: "Paper", value: "Premium photo paper" },
      { label: "Finish", value: "Glossy, Matte, Lustre" },
      { label: "Resolution", value: "High-quality 300 DPI" },
      { label: "Quantity", value: "Single prints to bulk orders" },
      { label: "Turnaround", value: "Same day or 1-2 business days" }
    ]
  }
];

export const mockTestimonials = [
  {
    name: "Rajesh Kumar",
    business: "Kumar Enterprises",
    rating: 5,
    text: "Excellent quality and fast delivery. The business cards exceeded our expectations!"
  },
  {
    name: "Priya Sharma",
    business: "Creative Studio",
    rating: 5,
    text: "Very professional service. The brochures were perfect for our marketing campaign."
  },
  {
    name: "Amit Patel",
    business: "Tech Solutions",
    rating: 5,
    text: "Great pricing and amazing quality. Highly recommend for all printing needs."
  }
];
